<ces-asset-breadcrumb [trail]="breadcrumbTrail()" />

<div class="px-(--space-4)">
  <ces-route-title [title]="'navigation.routes.automaticMeasurements' | transloco" />

  @if (!currentAssetId()) {
    <div class="p-(--padding-card) text-center bg-yellow-100 border border-yellow-300 rounded-(--radius-md) mb-(--space-4)">
      <p>{{ 'common.messages.noAssetSelected.automaticMeasures' | transloco }}</p>
    </div>
  }

  <ces-generic-parent-grid
    [entityDefinition]="entityDefinition()"
    [entities]="entities()"
    [dataLoadingCompleted]="dataLoadingCompleted()"
    [paginator]="true"
    [totalRecords]="totalRecords()"
    [first]="first()"
    [rows]="rows()"
    [initialFilters]="urlFilters()"
    (lazyLoad)="onLazyLoad($event)" />
</div>
